// extracted by mini-css-extract-plugin
module.exports = {"container":"TextAreaInput_container__2jW3d","label":"TextAreaInput_label__38Pno","inputContainer":"TextAreaInput_inputContainer__ikESM","input":"TextAreaInput_input__3eEmK"};